import React from 'react';
import { PRICE } from '../data/halloweenKit';
type PriceTagProps = {
  size?: 'md' | 'lg' | 'xl';
  className?: string;
};
export function PriceTag({
  size = 'lg',
  className = ''
}: PriceTagProps) {
  const digit = size === 'xl' ? 'text-[4.5rem] sm:text-[5.5rem]' : size === 'lg' ? 'text-6xl sm:text-7xl' : 'text-5xl sm:text-6xl';
  return <p className={`font-display font-semibold leading-none text-cream-50 ${digit} ${className}`} data-id="element-227" data-mp="1ok8m8cxgvla1">
      {PRICE}
      <span className="ml-2 align-middle font-sans text-sm font-bold uppercase tracking-[0.14em] text-cream-300" data-id="element-228" data-mp="19v2pcvm3q75b">
        USD
      </span>
    </p>;
}